angular.module('app.filters').filter('paginate', () => (items, page, perPage) => {
    const start = (page - 1) * perPage;
    const end = page * perPage;

    return items.slice(start, end);
});
